import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { frequencyLabel, groupLabels, groupOrder } from '../../data/labels';
import { quickTaskPresets } from '../../data/neutralTemplate';
import { TaskGroup, TaskTemplate } from '../../types/family';
import { namesOf } from '../../utils/members';
import { Button } from '../ui/Button';
import { Chip } from '../ui/Form';
import { blankTemplate, TaskEditSheet } from './TaskEditSheet';
export function TasksSettings() {
  const {
    family
  } = useAppState();
  const [group, setGroup] = useState<TaskGroup>('hisa');
  const [editing, setEditing] = useState<TaskTemplate | null>(null);
  const list = family.templates.filter(t => t.group === group);
  return <div data-id="element-806" data-mp="14flqmcj5c6w5">
      <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-807" data-mp="14fvhe2c0mi2w">
        <div className="flex flex-wrap gap-2" data-id="element-808" data-mp="14diztqa669qd">
          {groupOrder.map(g => <Chip key={g} active={group === g} onClick={() => setGroup(g)} data-id="element-809" data-mp="19cc3ys3kgodv">
              {groupLabels[g]} · {family.templates.filter(t => t.group === g).length}
            </Chip>)}
        </div>
        <Button size="sm" onClick={() => setEditing(blankTemplate('', group))} data-id="element-810" data-mp="22t6uxon75pxy">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-811" data-mp="1xyb42rtp58mf" /> Nova naloga
        </Button>
      </div>
      <ul className="mt-4 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-812" data-mp="1t0rewwvgnbfp">
        {list.length === 0 && <li className="px-4 py-4 text-sm text-muted" data-id="element-813" data-mp="1ox37qfaqqhuz">V tej skupini še ni nalog.</li>}
        {list.map(t => <li key={t.id} data-id="element-814" data-mp="1f1022zgok13a">
            <button type="button" onClick={() => setEditing(t)} className="flex w-full items-center gap-3 px-4 py-3 text-left transition-colors duration-150 hover:bg-canvas" data-id="element-815" data-mp="1f2b7t4torix1">
              <span className="min-w-0 flex-1" data-id="element-816" data-mp="39f14tvfcp88n">
                <span className="block font-bold" data-id="element-817" data-mp="39erci16u2ozs">{t.title}</span>
                <span className="block text-xs text-muted" data-id="element-818" data-mp="34fy7yy9iy8br">
                  {t.assigneeIds.length ? namesOf(family, t.assigneeIds) : 'sprotni dogovor'} · {frequencyLabel(t.frequency)} · {t.confirmation === 'skrbnik' ? 'potrdi skrbnik' : 'na zaupanje'}
                  {t.transferable ? ' · prenosljivo' : ''}
                </span>
              </span>
              <span className="shrink-0 rounded-full bg-canvas px-2 py-0.5 text-xs font-extrabold" data-id="element-819" data-mp="sr00vy6l13b4">
                {t.baseValue ?? 0} {t.valueType === 'bonus' ? 'goodies' : 'cvenk.'}
              </span>
            </button>
          </li>)}
      </ul>
      <div className="mt-4" data-id="element-820" data-mp="1qfa76pdeid81">
        <p className="text-sm font-bold" data-id="element-821" data-mp="1qeik62xvdntd">Hitre predloge</p>
        <div className="mt-2 flex flex-wrap gap-2" data-id="element-822" data-mp="1cfsdpwp5ubsc">
          {quickTaskPresets.map(p => <Chip key={p} active={false} onClick={() => setEditing({
          ...blankTemplate(p, 'hisa'),
          confirmation: 'zaupanje',
          frequency: undefined
        })} data-id="element-823" data-mp="1ghdwfyodlkag">
              + {p}
            </Chip>)}
        </div>
      </div>
      <TaskEditSheet template={editing} onClose={() => setEditing(null)} data-id="element-824" data-mp="54tkanj3ef9a" />
    </div>;
}